import { redirect } from 'next/navigation'
import { LoginForm } from '@/components/login-form'
import { getCurrentAdmin } from '@/lib/admin-auth'

export default async function LoginPage() {
  const current = await getCurrentAdmin()

  if (current) {
    redirect('/dashboard')
  }

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <h1>Connexion admin</h1>
        <p>Accès réservé au support et à l’administration SenKredi.</p>
        <LoginForm />
      </section>
    </main>
  )
}
